// IndexedDB wrapper for offline operation queue
const DB_NAME = 'staynivo-offline';
const DB_VERSION = 1;
let _db = null;

function openDB() {
  if (_db) return Promise.resolve(_db);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const d = e.target.result;
      if (!d.objectStoreNames.contains('queue')) {
        const store = d.createObjectStore('queue', { keyPath: 'id', autoIncrement: true });
        store.createIndex('status', 'status', { unique: false });
      }
    };
    req.onsuccess  = (e) => { _db = e.target.result; resolve(_db); };
    req.onerror    = (e) => reject(e.target.error);
  });
}

export async function enqueue(op) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx    = db.transaction('queue', 'readwrite');
    const store = tx.objectStore('queue');
    const req   = store.add({ ...op, status: 'pending', retries: 0, createdAt: Date.now() });
    req.onsuccess = () => resolve(req.result);
    req.onerror   = () => reject(req.error);
  });
}

export async function getPending() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx    = db.transaction('queue', 'readonly');
    const store = tx.objectStore('queue');
    const idx   = store.index('status');
    const req   = idx.getAll('pending');
    req.onsuccess = () => resolve(req.result || []);
    req.onerror   = () => reject(req.error);
  });
}

export async function markSyncing(id) {
  const db = await openDB();
  return new Promise((resolve) => {
    const tx    = db.transaction('queue', 'readwrite');
    const store = tx.objectStore('queue');
    const r     = store.get(id);
    r.onsuccess = () => { if (r.result) { r.result.status = 'syncing'; store.put(r.result); } resolve(); };
    r.onerror   = () => resolve();
  });
}

export async function markFailed(id) {
  const db = await openDB();
  return new Promise((resolve) => {
    const tx    = db.transaction('queue', 'readwrite');
    const store = tx.objectStore('queue');
    const r     = store.get(id);
    r.onsuccess = () => { if (r.result) { r.result.status = 'pending'; r.result.retries = (r.result.retries||0)+1; store.put(r.result); } resolve(); };
    r.onerror   = () => resolve();
  });
}

export async function removeOp(id) {
  const db = await openDB();
  return new Promise((resolve) => {
    const tx = db.transaction('queue', 'readwrite');
    tx.objectStore('queue').delete(id).onsuccess = () => resolve();
  });
}

export async function countPending() {
  try {
    const db = await openDB();
    return new Promise((resolve) => {
      const tx  = db.transaction('queue', 'readonly');
      const idx = tx.objectStore('queue').index('status');
      const r   = idx.count('pending');
      r.onsuccess = () => resolve(r.result || 0);
      r.onerror   = () => resolve(0);
    });
  } catch { return 0; }
}
